import cn from 'classnames';

import { useTextStyle } from '@webapp/common/components/custom-styles';
import { setHtml } from '@webapp/common/lib/ui';

import css from './help-text.css';

export const HelpText: FC<{
    value: string;
    className?: string;
}> = ({ className, value }) => {
    const { textStyle } = useTextStyle();
    return value && <div className={cn(css.note, 'wysiwyg', className)} style={textStyle} {...setHtml(value)} />;
};
